
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marketplace/suppliers/[id]",
      function () {
        return require("private-next-pages/marketplace/suppliers/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/marketplace/suppliers/[id]"])
      });
    }
  